import { asyncModule } from '../../utils/async-module';
import * as JSModules from '../../components/modules';

export const asyncGlobalNavigation = () => {
  const $element = document.querySelector('.j-global-nav');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.globalNavModule);
    start();
    import('../../components/global-nav/global-nav').then(getInit()).catch(error);
  }
};

export const asyncLocalNavigation = () => {
  const $element = document.querySelector('.j-local-nav');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.localNavModule);
    start();
    import('../../components/local-navigation/local-navigation').then(getInit()).catch(error);
  }
};

export const asyncSectionNavigation = () => {
  const $element = document.querySelector('.j-section-nav');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.sectionNavModule);
    start();
    import('../../components/local-navigation/section-navigation').then(getInit()).catch(error);
  }
};
